import React from 'react';
import { Sheet, SheetContent, SheetHeader, SheetTitle } from 'src/shared/components/ui/sheet';
import RiskDriverItem, { type RiskDriverItemProps } from './RiskDriverItem';

type RiskDriversDrawerProps = {
    title: string;
    items: RiskDriverItemProps[];
    isOpen: boolean;
    onClose: () => void;
};

const RiskDriversDrawer = ({ title, items, isOpen, onClose }: RiskDriversDrawerProps) => (
    <Sheet open={isOpen} onOpenChange={open => !open && onClose()}>
        <SheetContent side='right' className='w-full sm:max-w-md flex flex-col p-0'>
            <SheetHeader className='p-4 border-b border-border'>
                <SheetTitle className='text-xl font-normal text-general-foreground'>
                    {title} ({items.length})
                </SheetTitle>
            </SheetHeader>

            <div className='flex-1 overflow-y-auto p-4'>
                <div className='flex flex-col'>
                    {items.map((item, i) => (
                        <div key={i} className='py-2'>
                            <RiskDriverItem {...item} />
                        </div>
                    ))}
                </div>
            </div>

            <div className='p-4 border-t border-border'>
                <button
                    data-testid='drawer-footer-close-button'
                    className='w-full rounded-lg px-3 py-2 text-sm bg-primary text-primary-foreground hover:bg-primary/90 transition-colors'
                    onClick={onClose}
                >
                    Close
                </button>
            </div>
        </SheetContent>
    </Sheet>
);

export default RiskDriversDrawer;
